import {
  BoltIcon,
  CubeIcon,
  HomeIcon,
  ShieldCheckIcon,
  Square3Stack3DIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';

import { Sidebar } from '@/components/layout/Sidebar';
import { CanvasRoutes, RouterConfig, Routes } from '@/configs/routes';

const items = Routes.filter((r) => r.showInNavigation && r.path.startsWith('/data/'));

const iconMap = {
  [RouterConfig[CanvasRoutes.DataHome].path]: HomeIcon,
  [RouterConfig[CanvasRoutes.DataCustomers].path]: UsersIcon,
  [RouterConfig[CanvasRoutes.DataProducts].path]: CubeIcon,
  [RouterConfig[CanvasRoutes.DataEvents].path]: BoltIcon,
  [RouterConfig[CanvasRoutes.DataQuality].path]: ShieldCheckIcon,
  [RouterConfig[CanvasRoutes.DataTransformations].path]: Square3Stack3DIcon,
};

// Section label rendered above Data Quality (mock: "Governance" divider before this item).
const dividers = {
  [RouterConfig[CanvasRoutes.DataQuality].path]: 'Governance',
};

export function DataSidebar() {
  return items.length > 0 ? (
    <Sidebar label="Data" items={items} iconMap={iconMap} dividers={dividers} depth={1} />
  ) : null;
}
